import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApiStatisticsFilters } from '../api/apiStatistics';

interface ApiStatisticsFiltersComponentProps {
  filters: ApiStatisticsFilters;
  onFiltersChange: (filters: ApiStatisticsFilters) => void;
}

export const ApiStatisticsFiltersComponent: React.FC<ApiStatisticsFiltersComponentProps> = ({ 
  filters, 
  onFiltersChange 
}) => {
  const { t } = useTranslation('apiStatistics');

  const handleFilterChange = (key: keyof ApiStatisticsFilters, value: string) => {
    onFiltersChange({ ...filters, [key]: value });
  };

  const handleClearFilters = () => {
    onFiltersChange({});
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            {t('date')}
          </label>
          <input
            type="date"
            value={filters.date || ''}
            onChange={(e) => handleFilterChange('date', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm text-gray-900 dark:text-white bg-white"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={() => onFiltersChange(filters)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium"
        >
          {t('search')}
        </button>
        <button
          onClick={handleClearFilters}
          className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md text-sm font-medium"
        >
          {t('clear')}
        </button>
      </div>
    </div>
  );
}; 